import { useIsomorphicLayoutEffect } from '@lemonade-hq/cdk';
import { floor } from 'lodash';
import { useEffect, useState } from 'react';
import { getRelativeScroll } from '../../hooks/useSmoothScroll';

declare global {
  interface Window {
    t: number;
    DocumentApproved: boolean;
    HtmlRunElement: () => string;
  }
}

const EASTER_EGG_EVENT = 'ole';
const EASTER_EGG_SCROLL = 0.83;

function setupEasterEgg(): void {
  window.HtmlRunElement = () => {
    if (window.DocumentApproved) {
      if (floor(getRelativeScroll(), 2) === EASTER_EGG_SCROLL) {
        window.dispatchEvent(new Event(EASTER_EGG_EVENT));
        return '😊';
      }
      return '🤭';
    }
    return '🤔';
  };
}

export function useGiveBack2021EasterEgg(t: number): boolean {
  const [enabled, setEnabled] = useState(false);
  useIsomorphicLayoutEffect(setupEasterEgg, []);

  useEffect(() => {
    window.t = t;
  });

  useEffect(() => {
    const handler = (): void => {
      setEnabled(true);
    };
    window.addEventListener(EASTER_EGG_EVENT, handler);

    return () => {
      window.removeEventListener(EASTER_EGG_EVENT, handler);
    };
  }, []);

  return enabled;
}
